import Form from 'src/utils/Form.js'

class Country extends Form {
  constructor(data, config = null) {
    super(data, config || Form.config)
  }

  fetch(then) {
    return super.get(`countries/${this.id}/edit`).then(data => {
      this.originalData = data
      for (let field in this.originalData) {
        this[field] = data[field]
      }
      then(data)
    })
  }

  static all(parameters, then) {
    return new Form().get(`countries?${parameters}`).then(then)
  }

  create(then) {
    return super.post('countries').then(then)
  }

  update(then) {
      return super.put(`countries/${this.id}`).then(then)
  }

  destroy(then) {
      return super.delete(`countries/${this.id}`).then(then)
  }
}

export default Country
